// Determines if the browser supports passive events
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
let passiveSupported = false;
try {
  const options = {
    get passive() {
      passiveSupported = true;
      return false;
    }
  };
  const noop = () => { };
  window.addEventListener("test", noop, options as any);
  window.removeEventListener("test", noop, options as any);
} catch (e) {
  passiveSupported = false;
}

export default function makePassiveEventOption(passive: boolean): boolean | { passive: boolean } {
  return passiveSupported ? { passive } : passive;
}